import React from 'react';
import { styled } from '@linaria/react';

import { Spinner } from '../icon';

const Loader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default () => {
  return (
    <Loader>
      <Spinner
        width="32"
        height="32"
      />
    </Loader>
  );
};
